 export default {
postNewWork:"Post new work",
viewMyJobs:"view my jobs",
architectBoard:"architect-Board" 
 }